import { ComponentIds, } from "@inter-ikea-core/core";
import { getMetaDataComponents } from "./functions/productUtils";
import { INHERITS } from "./constants";
export const MetaComponentApplier = (templates, components) => (entity) => {
    var _a;
    const collectTemplateIds = (template, ids) => {
        const findTemplate = (inheritedTemplateId) => ({ templateId }) => templateId === inheritedTemplateId;
        const getTemplates = (ids) => {
            var _a;
            return ((_a = template === null || template === void 0 ? void 0 : template.inherits) !== null && _a !== void 0 ? _a : []).flatMap((inheritedTemplateId) => {
                const inheritedTemplate = templates.find(findTemplate(inheritedTemplateId));
                if (!inheritedTemplate) {
                    console.error(`Inherited template with id "${inheritedTemplateId}" couldn't be found.`);
                }
                return collectTemplateIds(inheritedTemplate, ids);
            });
        };
        const other = !!template && INHERITS in template ? getTemplates(ids) : [];
        return [...other, ...(template ? [template.templateId] : []), ...ids];
    };
    const mergeObjects = (mainObject, secondaryObject) => {
        return Object.keys(mainObject).reduce((acc, curr) => {
            return Object.assign(Object.assign({}, acc), { [curr]: mainObject[curr] });
        }, secondaryObject);
    };
    const templateId = (_a = entity.getComponent(ComponentIds.TEMPLATE_DATA_COMPONENT_ID)) === null || _a === void 0 ? void 0 : _a.templateId;
    const template = templates.find((t) => t.templateId === templateId);
    //Since eg propping has no template
    if (!template) {
        return;
    }
    const ancestorMetaDataComponents = collectTemplateIds(template, []).reduce((acc, curr) => {
        var _a;
        const template = templates.find((t) => t.templateId === curr);
        const meta = (_a = template === null || template === void 0 ? void 0 : template.components) === null || _a === void 0 ? void 0 : _a.meta;
        const components = !!meta && "components" in meta ? meta.components : undefined;
        return !components ? acc : mergeObjects(components, acc);
    }, {});
    const metadata = getMetaDataComponents(entity) || {};
    const merged = mergeObjects(metadata, ancestorMetaDataComponents);
    Object.entries(merged).forEach(([componentKey, value]) => {
        const ComponentClass = componentKey in components
            ? components[componentKey]
            : undefined;
        if (!ComponentClass) {
            console.error(`${componentKey} couldn't be found.`);
            return;
        }
        const component = new ComponentClass(value);
        entity.addComponent(component);
    });
};
